<template>
  <div class="container">
    <p class="setup-wizard-general-info__desc">
    </p>
    <div class="table__table-wrapper">
      <div class="table-desc">
        {{ fields.recommended.desc }}
      </div>
      <template v-if="isDataLoaded">
        <div v-for="row in fields.recommended.fields"
              :key="row.id"
              class="table__table-row">
          <div class="table__table-row__field">
            {{ row.desc }}
          </div>
          <div class="table__table-row__field">
            <a target="_blank" class="table__table-row__field__value table__table-row__field__link" :href="row.link">Learn More</a>
          </div>
        </div>
      </template>
    </div>
    <div class="table__table-wrapper">
      <div class="table-desc">
        {{ fields.system.desc }}
      </div>
        <div class="table__table-row">
          <div class="table__table-row__title">Action Item</div>
          <div class="table__table-row__title">
            Status
          </div>
          <div class="table__table-row__title">
            Knowledge Center
          </div>
        </div>
      <template v-if="isDataLoaded">
        <div v-for="row in fields.system.fields"
              :key="row.id"
              class="table__table-row">
          <div class="table__table-row__field">
            <router-link class="table__table-row__field__link" :to="{ name: row.route }" target="_blank">
              {{ row.desc }}
            </router-link>
          </div>
          <div class="table__table-row__field">
            <span class="table__table-row__field__value">
              {{ data[row.id] > 0 ? 'Completed' : 'To-Do' }}
            </span>
            <!-- <base-material-design-icon @click="openPage(row.id)" class="table__table-row__field__icon" icon="openInNew"/> -->
          </div>
          <div class="table__table-row__field">
            <a target="_blank" class="table__table-row__field__value table__table-row__field__link" :href="row.kbLink">Learn More</a>
          </div>
        </div>
      </template>
    </div>
    <div class="table__table-wrapper">
      <div class="table-desc">
        {{ fields.more.desc }}
      </div>
        <div class="table__table-row">
          <div class="table__table-row__title">Action Item</div>
          <div class="table__table-row__title">
            Status
          </div>
          <div class="table__table-row__title">
            Knowledge Center
          </div>
        </div>
      <template v-if="isDataLoaded">
        <div v-for="row in fields.more.fields"
              :key="row.id"
              class="table__table-row">
          <div class="table__table-row__field">
            <router-link class="table__table-row__field__link" :to="{ name: row.route }" target="_blank">
              {{ row.desc }}
            </router-link>
          </div>
          <div class="table__table-row__field">
            <span class="table__table-row__field__value">
              {{ data[row.id] > 0 ? 'Completed' : 'To-Do' }}
            </span>
            <!-- <base-material-design-icon @click="openPage(row.id)" class="table__table-row__field__icon" icon="openInNew"/> -->
          </div>
          <div class="table__table-row__field">
            <a target="_blank" class="table__table-row__field__value table__table-row__field__link" :href="row.kbLink">Learn More</a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AccountChecklist',
  data () {
    return {
      errorFields: {},
      isDataUpdating: false,
      activeCard: 0,
      data: null,
      isDataLoaded: false,
      fields: {
        recommended: {
          desc: 'Recommended before you start your project',
          fields: [
            {
              id: 0,
              desc: 'Set up Keywords Everywhere for keyword research',
              link: 'https://knowledge.audiencekey.com/knowledgebase/setting-up-keywords-everywhere/'
            },
            {
              id: 1,
              desc: 'Install the Content Brief Locator',
              link: 'https://knowledge.audiencekey.com/knowledgebase/quick-access-to-content-briefs/'
            }
          ]
        },
        system: {
          desc: 'System Setup Checklist',
          fields: [
            {
              id: 'keyword_count',
              desc: 'Add Keywords',
              route: 'keyword-census',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/quick-add-keywords/'
            },
            {
              id: 'url_count',
              desc: 'Add URLs',
              route: 'url-census',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/add-or-update-single-urls/'
            },
            {
              id: 'project_members_count',
              desc: 'Invite Additional Team members',
              route: 'project-membership',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/project-member-management/'
            },
            {
              id: 'web_property_count',
              desc: 'Add Competitor & Sibling Web Properties',
              route: 'web_property',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/how-to-add-a-web-property-to-your-account/'
            }
          ]
        },
        more: {
          desc: 'Further Organize and Enhance your Data',
          fields: [
            {
              id: 'keyword_attribute_count',
              desc: 'Add a Keyword Attribute',
              route: 'keyword-attributes',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/how-to-create-a-keyword-attribute/'
            },
            {
              id: 'section_count',
              desc: 'Create URL Sections',
              route: 'section',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/how-to-create-a-section/'
            },
            {
              id: 'url_attribute_count',
              desc: 'Create a URL Attribute',
              route: 'url-attributes',
              kbLink: 'https://knowledge.audiencekey.com/knowledgebase/how-to-create-a-url-attribute/'
            }
          ]
        }
      }
    }
  },
  async created () {
    this.data = await this.loadChecklist(this.clientId)
    this.isDataLoaded = true
  },
  methods: {
    ...mapActions('accountSetup', ['loadChecklist']),
    ...mapActions('client', ['getClientsSettings']),
    openPage (id) {
      let route = ''
      switch (id) {
        case 'keyword_count':
          route = '/dashboard#/strategy/keyword-census'
          break
        case 'sibling_web_property_count':
          route = '/dashboard#/settings/web_property'
          break
        case 'competitor_web_property_count':
          route = '/dashboard#/settings/web_property'
          break
        case 'section_count':
          route = '/dashboard#/settings/section'
          break
        case 'keyword_attribute_count':
          route = '/dashboard#/settings/keyword-attributes'
          break
        case 'url_attribute_count':
          route = '/dashboard#/settings/url-attributes'
          break
        case 'project_members_count':
          route = '/dashboard#/settings/project-membership'
          break
        default:
          return
      }
      const routeData = this.$router.resolve({ path: route })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-arrow {
    padding: 4px;
    border: solid $rfx-dark-march;
    border-width: 0 2px 2px 0;
    display: inline-block;
    margin-bottom: 1px;
  }
  .btn-arrow-right {
    transform: rotate(315deg);
    border-color: #fff;
  }
  .btn-arrow-left {
    transform: rotate(135deg);
  }

  .navigation-controls {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .table-desc {
    color: $rfx-dark-march;
    font-weight: bold;
    font-size: 16px;
    background-color: #fff;
    padding: 15px 15px 15px 25px;
    background-color: $rfx-light-steel;
  }
  .table {
    position: relative;
    min-height: 200vh !important;

    &__title-left {
      display: flex;
      align-items: center;
    }

    &__title-left > *:not(:last-child) {
      margin-right: 30px;
    }

    &__title-container {
      padding: 14px 0;
      display: flex;
      align-items: center;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 0;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__table-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      border-top: 1px solid $rfx-light-steel;
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
      border-radius: $rfx-default-border-radius;
      margin-bottom: 20px;
    }

    &__table-row {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      width: 100%;
      background-color: #fff;
      border-bottom: 1px solid $rfx-light-steel;

      &:first-child {
        border-top-left-radius: $rfx-default-border-radius;
        border-top-right-radius: $rfx-default-border-radius;

        input {
          border-top-right-radius: $rfx-default-border-radius;
        }
      }

      &:last-child {
        border-bottom-left-radius: $rfx-default-border-radius;
        border-bottom-right-radius: $rfx-default-border-radius;
      }

      &__title {
        color: $rfx-dark-march;
        flex: 1;
        font-weight: bold;
        padding: 15px 0 15px 25px;
        font-size: 14px;
        border-right: 1px solid $rfx-light-steel;
        &:last-child {
          border-right: none;
        }
      }

      &__field {
        // display: flex;
        // justify-content: space-between;
        // flex: 2;
        padding: 15px 15px 15px 25px;
        // border: 1px solid transparent;
        border-right: 1px solid $rfx-light-steel;
        &:last-child {
          border-right: none;
        }

        &_err {
          border: 1px solid $rfx-light-red !important;
        }

        &::placeholder {
          color: $rfx-dark-march;
        }

        &__value {
          // display: block;
        }
        &__icon {
          // height: 1px;
          // color: red;
        }
        &__link {
          text-decoration: none;
          cursor: pointer;
          color: $rfx-bright-blue !important;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    &__select {
      padding: 3px 0 3px 25px !important;
      height: 60px !important;

      &::v-deep .select__input {
        position: relative;
        left: -22px;
        padding-left: 22px;
      }

      &::v-deep .select__input-container {
        background-color: #fff;
        margin-left: -4px;
      }

    }

    &__field_disabled {
      pointer-events: none !important;
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &__button {
        min-width: 100px;
        padding: 0 25px;
        height: 40px;
        font-size: 10px;
        font-weight: 900;
        cursor: pointer;
        text-transform: uppercase;
        border-radius: 8px;
        outline: none;
        border: none;
        color: #fff;
        background-color: $rfx-dark-march;
      }
    }
  }
</style>
